
import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import "./Aboutus.css";

import AboutUsMain from "../../assets/images/AboutUsMain.png";

const AboutUs = () => {
    return (
      <>
        <div className="d-flex align-items-center justify-content-center min-vh-100">
          <Container fluid className="d-flex justify-content-center">
            <Row className="d-flex justify-content-center">
              <Col
                lg={6}
                md={12}
                sm={12}
                className="d-flex flex-column align-items-center justify-content-center text-center"
              >
                <div
                  className={`${window.innerWidth < 992 ? "my-5" : ""}`}
                ></div>
                <div className="content-container">
                  <div className="mb-4">
                    <h2 className="fs-1">
                      About <span className="text-warning fw-bold">Us</span>
                    </h2>
                  </div>
                  <div className="px-3 px-md-5">
                    <p className="about-p fw-normal">
                      LankaLearners.lk is a free educational platform created by
                      MechSIT (Pvt) Ltd to support Sri Lankan learners preparing
                      for the Driving License Written Exam. It offers easy
                      access to model multiple-choice questions and answers in
                      Sinhala, Tamil, and English, helping users study the road
                      rules in a convenient and structured way. Whether you’re
                      getting ready for your first attempt or revisiting exam
                      materials, LankaLearners.lk is built to make your learning
                      journey smoother, more accessible, and exam-focused.
                    </p>
                  </div>
                  <div className="d-flex px-3 px-md-5 justify-content-center">
                    <a
                      href="https://mecsit.com/portfolio/application/?name=SLDL"
                      target="mechsit"
                    >
                      <button
                        type="button"
                        className="btn btn-warning btn-lg mb-2 text-light"
                      >
                        See More{" "}
                        <i className="fa fa-chevron-circle-right p-2"></i>
                      </button>
                    </a>
                  </div>
                </div>
              </Col>
              <Col
                lg={6}
                md={12}
                sm={12}
                className="d-flex flex-column align-items-center justify-content-center my-4 mt-lg-0"
              >
                <Image
                  src={AboutUsMain}
                  className="bg-img img-fluid"
                  alt="driving licence exam questions and answers"
                />
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
};

export default AboutUs;
